/** Per-cohort example inputs. These are illustrative examples, not market data. */
export interface CohortConfig {
  slug: 'ceramics' | 'jewelry' | 'woodworking';
  craftParam: 'ceramics' | 'jewelry' | 'wood';
  craftLabel: string;
  path: string;
  /** Singular object used in "Example: a $N <object>". */
  object: string;
  plural: string;
  /** Three example price points, dollars. The middle one is the calculator default. */
  prices: [number, number, number];
  shipping: number;
  ordersPerMonth: number;
}

export const COHORTS: Record<CohortConfig['slug'], CohortConfig> = {
  ceramics: { slug: 'ceramics', craftParam: 'ceramics', craftLabel: 'Ceramics & pottery', path: '/sell/ceramics', object: 'mug', plural: 'mugs', prices: [28, 60, 140], shipping: 9, ordersPerMonth: 20 },
  jewelry: { slug: 'jewelry', craftParam: 'jewelry', craftLabel: 'Jewelry', path: '/sell/jewelry', object: 'pair of earrings', plural: 'pairs of earrings', prices: [25, 65, 180], shipping: 5, ordersPerMonth: 25 },
  woodworking: { slug: 'woodworking', craftParam: 'wood', craftLabel: 'Wood & home objects', path: '/sell/woodworking', object: 'cutting board', plural: 'cutting boards', prices: [35, 85, 220], shipping: 12, ordersPerMonth: 15 },
};
export const COHORT_LIST = [COHORTS.ceramics, COHORTS.jewelry, COHORTS.woodworking];
export const COHORT_PATHS = COHORT_LIST.map(cohort => cohort.path);
